import { DOCTORS_BASE } from "../components/Clinic/AdminDoctors/doctorConstants";

/** Путь к карточке тренера в админке / портале владельца */
export function adminTrainerProfilePath(trainerId) {
  if (!trainerId) return null;
  return `${DOCTORS_BASE}/${trainerId}`;
}

export function trainerIdFromSession(row) {
  if (!row) return null;
  return (
    row.doctor_id ||
    row.doctor?.id ||
    row.trainer?.id ||
    row.trainer_id ||
    null
  );
}

/** Users.id тренера (для социального профиля в клиентском приложении). */
export function trainerUserIdFromSession(row) {
  if (!row) return null;
  return row.doctor?.user_id || row.trainer?.user_id || null;
}

export function clientTrainerProfilePath(row) {
  const userId = trainerUserIdFromSession(row);
  if (!userId) return null;
  return `/app/members/${userId}`;
}

/** Тренер занятия — тот же, что и у текущего пользователя (владелец-тренер). */
export function isOwnTrainerRecord(trainerId, myTrainerId) {
  if (!trainerId || !myTrainerId) return false;
  return String(trainerId) === String(myTrainerId);
}
